import { Box } from '@material-ui/core';
import React from 'react';

import { usePageContext } from '../../../../contexts/PageContext/PageContext';

export const Widgets = ({ notShownInRightMenuOnly }: { notShownInRightMenuOnly?: boolean }) => {
  const {
    state: { widgets },
  } = usePageContext();

  const widgetsToShow = notShownInRightMenuOnly
    ? widgets.filter((widget) => widget.notShownInRightMenu === true)
    : widgets;

  return (
    <Box width={'100%'}>
      {widgets?.length > 0 && (
        <>
          {/*<Box mb={2}>*/}
          {/*  <Font variant={'subtitle1'} color={'title'}>*/}
          {/*    <Text tId={'MANAGEMENT'} />*/}
          {/*  </Font>*/}
          {/*</Box>*/}
          {widgetsToShow.map((widget, i) => {
            const el = React.createElement(widget.id.type, widget.props);
            return <div key={i}>{el}</div>;
          })}
        </>
      )}
    </Box>
  );
};
